import api from '@/api';

import { API_BASE_URL } from '..';
import {
  DeliveryDetailsIdResponse,
  DeliveryMaterialCreateResponse,
  deliveryMaterialDTO,
  deliveryMaterialRequest,
  ListStockPartsDeliveryDataSupport,
} from './DeliveryMaterial.types';
import { PageResultStock } from '@/core/request/PageResultStock';

const CONTROLLER_URL = `${API_BASE_URL}/materials`;

export async function deliveryMaterial(
  obj: deliveryMaterialDTO,
): Promise<DeliveryMaterialCreateResponse> {
  const result = (await api.post(
    `${CONTROLLER_URL}/deliveries`,
    obj,
    null,
  )) as unknown;

  return result as DeliveryMaterialCreateResponse;
}

export async function listStockPartsDelivery(
  obj: deliveryMaterialRequest,
): Promise<PageResultStock<ListStockPartsDeliveryDataSupport>> {
  const result = (await api.get(
    `${CONTROLLER_URL}/deliveries/items`,
    obj,
  )) as unknown;

  return result as PageResultStock<ListStockPartsDeliveryDataSupport>;
}

export async function getDeliveryDetailsId(id?: string) {
  const result = (await api.get(
    `${CONTROLLER_URL}/deliveries/${id}`,
    {},
  )) as unknown;

  return result as DeliveryDetailsIdResponse;
}
